import { render, staticRenderFns } from "./addProviceAdmin.vue?vue&type=template&id=957ece92&scoped=true&"
import script from "./addProviceAdmin.vue?vue&type=script&lang=js&"
export * from "./addProviceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addProviceAdmin.vue?vue&type=style&index=0&id=957ece92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957ece92",
  null
  
)

export default component.exports